import React from 'react';

import { useTranslation } from '@common/hooks/translation';
import NumericInput from '@common/components/numericInput';
import { formatCpfNumber } from '@app/dev/helpers/formatCpfNumber';

export const PinForm = ({ form, errors, setForm }) => {
  const t = useTranslation();

  return (
    <>
      <div className="title-row">
        <div className="title-row-text">{t('Reset Pin')}</div>
      </div>

      <p className="text-center">{t('Please set the new pin code')}</p>

      <div className="input-wrapper">
        <p className="popup-txt">{t('CPF NUMBER')}</p>
        <div className="input-row">
          <NumericInput
            className="sup-input"
            onChange={(val) => setForm({ ...form, cpf: formatCpfNumber(val) })}
            value={form.cpf}
            customFormat
          />
        </div>
        {errors.cpf && (
          <div className="error-row">
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t(errors.cpf)}</p>
          </div>
        )}
        <p className="popup-txt">{t('PIN Code')}</p>
        <div className="input-row">
          <NumericInput
            className="sup-input"
            type="password"
            onChange={(val) => setForm({ ...form, pin: val })}
            value={form.pin}
            maxLength={4}
          />
        </div>
        {errors.pin && (
          <div className="error-row">
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t(errors.pin)}</p>
          </div>
        )}
        <p className="popup-txt">{t('CONFIRM PIN CODE')}</p>
        <div className="input-row">
          <NumericInput
            className="sup-input"
            type="password"
            onChange={(val) => setForm({ ...form, confirmPin: val })}
            value={form.confirmPin}
            maxLength={4}
          />
        </div>
        {errors.confirmPin && (
          <div className="error-row">
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t(errors.confirmPin)}</p>
          </div>
        )}
      </div>
    </>
  );
};
